import { render, staticRenderFns } from "./modal-test.vue?vue&type=template&id=79af2f7c&scoped=true"
import script from "./modal-test.vue?vue&type=script&lang=js"
export * from "./modal-test.vue?vue&type=script&lang=js"
import style0 from "./modal-test.vue?vue&type=style&index=0&id=79af2f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af2f7c",
  null
  
)

export default component.exports